export default "__VITE_ASSET__a90da022__"